// the v2 config imports the css driver on web and react-native on native
// for reanimated: @tamagui/config/v2-reanimated
// for react-native only: @tamagui/config/v2-native
import { config } from "@tamagui/config/v3";
import { createTamagui } from "tamagui";

/**
 * 全站字體堆疊。
 *
 * 為什麼要覆寫：@tamagui/config/v3 的 body / heading 都指到 Inter 的堆疊
 * （`Inter, -apple-system, system-ui, …, sans-serif`），裡面**一個中文字體都沒有**。
 * Tamagui 的 <Text> 一律吃這串，body 上設的 font-family 蓋不掉它。
 * 結果是 iOS 靠 -apple-system 撿到蘋方還算能看，Android 的 LINE WebView 則常挑到
 * Noto Sans CJK **SC**，「骨、直、產、戶」這些字會出現簡體字形。
 *
 * 'Inter' 排在最前面吃掉拉丁字母與數字，'Huninn'（jf open 粉圓）接手中文——
 * Inter 沒有中文字符，中文自然往後掉，不需要任何 unicode-range 設定。
 * 分工的理由見 src/styles/all.scss 的 --font-sans。
 * 注意：粉圓只有 400 一個字重，中文的 700／800 仍是瀏覽器合成的假粗體。
 * 原生 HTML 那一半（大量手寫 div／button）吃的是 src/styles/all.scss 的 --font-sans，
 * 兩份必須逐字相同，否則同一個畫面會出現兩種字。改這裡就要一起改那裡。
 * 要退回系統字只要把 'Huninn' 從兩處拿掉，其餘不動。
 */
const FONT_STACK =
  '"Inter", "Huninn", -apple-system, BlinkMacSystemFont, "PingFang TC", "Noto Sans TC", "Microsoft JhengHei", "Segoe UI", Roboto, sans-serif';

const tamaguiConfig = createTamagui({
  ...config,
  fonts: {
    ...config.fonts,
    body: { ...config.fonts.body, family: FONT_STACK },
    heading: { ...config.fonts.heading, family: FONT_STACK },
  },
});

// this makes typescript properly type everything based on the config
type Conf = typeof tamaguiConfig;
declare module "tamagui" {
  interface TamaguiCustomConfig extends Conf {}
}

export default tamaguiConfig;

// depending on if you chose tamagui, @tamagui/core, or @tamagui/web
// be sure the import and declare module lines both use that same name
